'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var isEmpty = (function (data) { return !data || !data.trim().length; });

exports.default = isEmpty;
//# sourceMappingURL=index.js.map
